"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dribbble = function Dribbble(props) {
	return _react2.default.createElement(
		"svg",
		_extends({}, props, { viewBox: "0 0 48 48" }),
		_react2.default.createElement("path", { d: "M24 6a18 18 0 1 0 18 18A18 18 0 0 0 24 6zm14.828 17.162a32.1 32.1 0 0 0-10.655-.11 61.235 61.235 0 0 0-1.15-2.52 21.24 21.24 0 0 0 8.322-6.123 14.8 14.8 0 0 1 3.483 8.752zm-5.763-10.924a18.2 18.2 0 0 1-7.48 5.52A69.43 69.43 0 0 0 20.354 9.6a14.658 14.658 0 0 1 12.712 2.638zm-15.775-1.49a66.888 66.888 0 0 1 5.31 8.072 47.706 47.706 0 0 1-13.03 1.658 14.9 14.9 0 0 1 7.72-9.73zM9.13 24l.02-.384a50.31 50.31 0 0 0 14.926-1.983Q24.6 22.7 25.08 23.78a23.168 23.168 0 0 0-12.506 9.72A14.8 14.8 0 0 1 9.13 24zm5.744 11.716a20.216 20.216 0 0 1 11.4-9.04 58.71 58.71 0 0 1 3.065 11.19 14.737 14.737 0 0 1-14.466-2.15zm17.38.645a61.653 61.653 0 0 0-2.88-10.345 29.952 29.952 0 0 1 9.3.294 14.885 14.885 0 0 1-6.42 10.05z" })
	);
};

exports.default = Dribbble;


//////////////////
// WEBPACK FOOTER
// ./~/react-share-icons/lib/Dribbble/index.js
// module id = 170
// module chunks = 0